import { h } from "preact";
import * as React from "react";
import { Format } from "../utils/format";

const VariationStyles = {
  DirectionColor: {
    down: {
      color: "#b9292d",
    },
    up: {
      color: "#35bd5b",
    },
  },
};

const PanelStyle = {
  MinPadding: {
    padding: "2px 0px 2px 0px",
  },
  NoPadding: {
    padding: "0px 0px 0px 1px",
  },
  RightPadding: {
    padding: "0px 15px 0px 1px",
  },
};
const ArrowUp = "fa fa-long-arrow-up";
const ArrowDown = "fa fa-long-arrow-down";

export interface IProps {
  title: string;
  arrowDirection?: string;
  arrowColor?: {};
  value: string;
  label?: string;
  labelValue?: string;
  unit: boolean;
}

export function YtdFiguresRow(props: IProps) {
  return (
    <div class="row" style={PanelStyle.MinPadding}>
      <div class="col-xs-3 text-right" style={PanelStyle.NoPadding}>
        <b>{props.title}</b>
      </div>
      <div class="col-xs-1 text-right" style={PanelStyle.NoPadding}>
        <i
          class={props.arrowDirection}
          style={props.arrowColor}
          aria-hidden="true"
        />
      </div>
      <div class="col-xs-4 text-right" style={PanelStyle.NoPadding}>
        <b>
          {props.value}
          {props.unit === true ? "\u0024" : "\u20AC"}
        </b>
      </div>
      <div class="col-xs-4 text-right" style={PanelStyle.RightPadding}>
        <span style="width: 90%" class={props.label}>
          <b>{props.labelValue}</b>
        </span>
      </div>
    </div>
  );
}
